module.exports = __webpack_public_path__ + "media/images/fretadao-gray-logo-4d8e9c05942c4c0e91636734cfda238b.png";